import { TRaceProgressInstance } from '../libs/store';
import { TAction } from './types/action';

// Action Types
export const GET_RACE_PROGRESS = 'GET_RACE_PROGRESS';

export type TGetRaceProgressAction = TAction<{
  instanceId: string;
  raceProgress: TRaceProgressInstance;
}>;

// Action Creators
export function createActionGetRaceProgress(
  instanceId: string,
  raceProgress: TRaceProgressInstance
): TGetRaceProgressAction {
  return {
    type: GET_RACE_PROGRESS,
    payload: {
      instanceId,
      raceProgress
    }
  };
}
